import { useEffect, useRef } from 'react';

const usePaginationScroll = (currentPage, offset = 20) => {
	const scrollTargetRef = useRef(null);
	const isFirstLoad = useRef(true);

	useEffect(() => {
		if (isFirstLoad.current) {
			isFirstLoad.current = false;
			return;
		}

		if (!scrollTargetRef.current) return;

		const containerTop = scrollTargetRef.current.offsetTop;

		window.scrollTo({
			top: containerTop - offset,
			behavior: 'smooth'
		});
	}, [currentPage, offset]);

	return { scrollTargetRef };
};

export default usePaginationScroll;
